import { render, staticRenderFns } from "./ClientEquityHistoryCharts.vue?vue&type=template&id=65c695c2&"
import script from "./ClientEquityHistoryCharts.vue?vue&type=script&lang=js&"
export * from "./ClientEquityHistoryCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports